import DerivedAttributesPage from './DerivedAttributesPage';

export default DerivedAttributesPage;
